import { path } from 'ramda';
export var selectFilters = function selectFilters(state) {
  return state.filters;
};
export var selectDeviceType = function selectDeviceType(state) {
  return path(['page', 'deviceType'], state);
};